/* GOSSIP HERO — two-level carousel (thegossip.hu)
   OUTER: brand slides. INNER: per-slide product frames (image + pills) that
   auto-rotate; when a brand's products finish cycling, the brand advances.
   One timer drives both. No dependencies. Accessible, reduced-motion safe.
   Markup contract (sections/gossip-hero.liquid):
     [data-gossip-hero] (data-autoplay, data-product-interval)
       [data-hero-track] > li[data-hero-slide] > .gossip-hero__media [data-product-rotator] > [data-product-frame]
       [data-hero-prev] [data-hero-next] button[data-hero-dot=i] [data-hero-live] */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.heroInit === '1') return;
    root.dataset.heroInit = '1';

    var track = root.querySelector('[data-hero-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');
    var live = root.querySelector('[data-hero-live]');
    if (!track || slides.length === 0) return;

    var frames = slides.map(function (s) {
      return Array.prototype.slice.call(s.querySelectorAll('[data-product-frame]'));
    });
    var frameIdx = slides.map(function () { return 0; });

    var count = slides.length;
    var index = 0;
    var timer = null;
    var paused = false;

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayOn = root.dataset.autoplay === 'true' && !reduceMotion;
    var interval = parseInt(root.dataset.productInterval, 10) || 4000;
    if (interval < 2000) interval = 2000;

    function showFrame(si, fi) {
      var fr = frames[si];
      for (var i = 0; i < fr.length; i++) {
        var on = i === fi;
        fr[i].classList.toggle('is-current', on);
        fr[i].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
    }

    function renderSlide() {
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = active ? 0 : -1; });
      });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
      if (live) live.textContent = (index + 1) + ' / ' + count;
    }

    function goToSlide(i) {
      index = (i + count) % count;
      frameIdx[index] = 0;       // each brand starts from its first product
      showFrame(index, 0);
      renderSlide();
    }

    /* one tick: advance product within brand; when products exhausted, next brand */
    function tick() {
      var fr = frames[index];
      if (fr.length > 1 && frameIdx[index] < fr.length - 1) {
        frameIdx[index]++;
        showFrame(index, frameIdx[index]);
      } else {
        goToSlide(index + 1);
      }
    }

    function start() { if (!autoplayOn || paused || timer) return; timer = window.setInterval(tick, interval); }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    function pause() { paused = true; stop(); }
    function resume() { paused = false; start(); }

    /* manual brand nav */
    function nextBrand() { goToSlide(index + 1); }
    function prevBrand() { goToSlide(index - 1); }
    if (nextBtn) nextBtn.addEventListener('click', function () { nextBrand(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prevBrand(); restart(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goToSlide(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0); restart(); });
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); nextBrand(); restart(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prevBrand(); restart(); }
    });

    /* pause on hover / focus / tab hidden */
    root.addEventListener('pointerenter', pause);
    root.addEventListener('pointerleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) resume(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else if (!paused) start(); });

    /* touch / pointer swipe (changes brand) */
    var viewport = root.querySelector('[data-hero-viewport]') || track;
    var startX = 0, startY = 0, dragging = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; startX = e.clientX; startY = e.clientY; pause();
    });
    viewport.addEventListener('pointerup', function (e) {
      if (!dragging) return; dragging = false;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) nextBrand(); else prevBrand(); }
      resume();
    });
    viewport.addEventListener('pointercancel', function () { dragging = false; resume(); });

    // init
    showFrame(0, 0);
    renderSlide();
    start();
  }

  function initAll() { document.querySelectorAll('[data-gossip-hero]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-gossip-hero]');
    if (root) { root.dataset.heroInit = ''; initCarousel(root); }
  });
})();
